/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Import_Choosefile1Inputs */



/**
* | output |
* | --- |
* | "Choose a file" |
*
* @param {Alarms_Import_Choosefile1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_import_choosefile1 = /** @type {((inputs?: Alarms_Import_Choosefile1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Import_Choosefile1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Choose a file")
	return /** @type {LocalizedString} */ ("Choisir un fichier")
});
export { alarms_import_choosefile1 as "alarms_import_chooseFile" }